export default __webpack_public_path__ + "assets/images/image-battle-royale.61f14eb6.png";